<template>
    <div class = "experience-scoll-page">
        <div class="experience-page  hidden-sm-and-down">
            <div class="first-page">
                <img src="../assets/img/ExperienceDesignMain.jpg" alt="">
                <div class="first-page-title" v-if="this.isEn != '1'">
                    <div>体验设计</div>
                    <div></div>
                    <div>因为专业 所以易用</div>
                </div>
              <div class="first-page-title" v-if="this.isEn == '1'">
                <div>Experience Design</div>
                <div></div>
                <div>Easy to use because of its specialty</div>
              </div>
            </div>

            <div class="about-content row">
                <div id="miao1" class="row col-md-90">
                    <div class="col-md-4">
                        <div class="about-content-img about-content-img-left">
                            <img src="../assets/img/design1_img.png" alt="">
                        </div>
                    </div>
                    <div class="col-md-8 about-content-text about-content-text-right" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            行业认识
                        </div>
                        <div class="about-content-describe">
                            德卡拥有15年卡产品相关行业经验，对行业形态认识深刻，信息政策理解全面到位。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                  <div class="col-md-8 about-content-text about-content-text-right" v-if="this.isEn == '1'">
                    <div class="about-content-title">
                      Industry awareness
                    </div>
                    <div class="about-content-describe">
                      Decard has 15 years of experience in the industry related to card products, with a deep understanding of the industry form and a comprehensive understanding of information policies.
                    </div>
                    <div class="about-content-line"></div>
                  </div>
                </div>
                <div id="miao2" class="row col-md-90 about-content-margin">
                    <div class="col-md-8 about-content-text about-content-text-left"  v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            场景调研
                        </div>
                        <div class="about-content-describe">
                            多名从业10年以上的产品人，从现场实地收集资料，到分析用户，只为您量身定制产品方案。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                  <div class="col-md-8 about-content-text about-content-text-left"  v-if="this.isEn == '1'">
                    <div class="about-content-title">
                      Business Scenario Investigations
                    </div>
                    <div class="about-content-describe">
                      Many people who have been engaged in the field for more than 10 years, from field data collection to user analysis, have only customized product solutions for you.
                    </div>
                    <div class="about-content-line"></div>
                  </div>
                    <div class="col-md-4">
                        <div class="about-content-img about-content-img-right">
                            <img src="../assets/img/design2_img.png" alt="">
                        </div>
                    </div>
                </div>
                <div id="miao3" class="row col-md-90 about-content-margin">
                    <div class="col-md-4">
                        <div class="about-content-img about-content-img-left">
                            <img src="../assets/img/design3_img.png" alt="">
                        </div>
                    </div>
                    <div class="col-md-8 about-content-text about-content-text-right" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            硬件设计
                        </div>
                        <div class="about-content-describe">
                            从人本需求出发，结合人机工程学，为客户在真实环境下设计易用、好用的硬件产品。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                  <div class="col-md-8 about-content-text about-content-text-right" v-if="this.isEn == '1'">
                    <div class="about-content-title">
                      Handware design
                    </div>
                    <div class="about-content-describe">
                      Based on human needs and ergonomics, we will design easy-to-use hardware products for customers in real environments.
                    </div>
                    <div class="about-content-line"></div>
                  </div>
                </div>
                <div id="miao4" class="row col-md-90 about-content-margin">
                    <div class="col-md-8 about-content-text about-content-text-left"  v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            UI&交互设计
                        </div>
                        <div class="about-content-describe">
                            专业软件设计研发团队，即可为硬件提供配套服务，也可单独为用户定制行业软件。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="col-md-8 about-content-text about-content-text-left" v-if="this.isEn == '1'">
                        <div class="about-content-title">
                           UI& Interaction Design
                        </div>
                        <div class="about-content-describe">
                            The professional software research and development team can either provide supporting services for hardware or customize industry software for users separately.
                        </div>
                    <div class="about-content-line"></div>
                    </div>
                    <div class="col-md-4">
                        <div class="about-content-img about-content-img-right">
                            <img src="../assets/img/design4_img.png" alt="">
                        </div>
                    </div>
                </div>
                <div id="miao5" class="row col-md-90 about-content-margin">
                    <div class="col-md-4">
                        <div class="about-content-img about-content-img-left">
                            <img src="../assets/img/design5_img.png" alt="">
                        </div>
                    </div>
                    <div class="col-md-8 about-content-text about-content-text-right" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            产品服务
                        </div>
                        <div class="about-content-describe">
                            为客户的需求负责，提供结合硬件，软件，云服务，现场支持，全面一体的产品服务。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="col-md-8 about-content-text about-content-text-right" v-if="this.isEn == '1'">
                        <div class="about-content-title">
                          Product service
                        </div>
                        <div class="about-content-describe">
                          Responsible for customer needs, provide product services of the  combination of hardware, software, cloud services and  on-site support.
                       </div>
                       <div class="about-content-line"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="visible-sm-and-down" style="margin-top:50px;">
            <div class="mobile-banner">
                    <img src="../assets/mobile/design01_img.jpg" alt="">
                </div>
                <div class="phone-content">
                    <div class="about-content-img">
                        <img src="../assets/img/design2_img.png" alt="" style="width:200px;">
                    </div>
                    <div class="about-content-text" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            行业认识
                        </div>
                        <div class="about-content-describe">
                            多名从业10年以上的产品人，从现场实地收集资料，到分析用户，只为您量身定制产品方案。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="about-content-text"  v-if="this.isEn == '1'">
                        <div class="about-content-title">
                          Industry awareness
                        </div>
                        <div class="about-content-describe">
                           Many people who have been engaged in the field for more than 10 years, from field data collection to user analysis, have only customized product solutions for you.
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                <div class="phone-content">
                    <div class="about-content-img">
                        <img src="../assets/img/design1_img.png" alt="" style="width:200px;">
                    </div>
                    <div class="about-content-text" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            场景调研
                        </div>
                        <div class="about-content-describe">
                            德卡拥有15年卡产品相关行业经验，对行业形态认识深刻，信息政策理解全面到位。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="about-content-text" v-if="this.isEn == '1'">
                        <div class="about-content-title">
                           Business Scenario Investigations
                        </div>
                        <div class="about-content-describe">
                           dekayongyou15niankachanpinxaingguanhangyejingyan,duihangyexingtairenshishenke,xinxizhencelijiequanmiandaowei。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                </div>
                </div>
                <div class="phone-content">
                    <div class="about-content-img">
                        <img src="../assets/img/design3_img.png" alt="" style="width:200px;">
                    </div>
                    <div class="about-content-text" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            硬件设计
                        </div>
                        <div class="about-content-describe">
                            从人本需求出发，结合人机工程学，为客户在真实环境下设计易用、好用的硬件产品。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="about-content-text" v-if="this.isEn == '1'">
                        <div class="about-content-title">
                          Handware design
                        </div>
                        <div class="about-content-describe">
                          Based on human needs and ergonomics, we will design easy-to-use hardware products for customers in real environments.
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                </div>
                <div class="phone-content">
                    <div class="about-content-img">
                        <img src="../assets/img/design4_img.png" alt="" style="width:200px;">
                    </div>
                    <div class="about-content-text" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            UI&交互设计
                        </div>
                        <div class="about-content-describe">
                            专业软件设计、研发团队，即可为硬件提供配套服务，也可单独为用户定制行业软件。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="about-content-text" v-if="this.isEn == '1'">
                        <div class="about-content-title">
                           UI& Interaction Design
                        </div>
                        <div class="about-content-describe">
                          The professional software research and development team can either provide supporting services for hardware or customize industry software for users separately.
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                </div>
                <div class="phone-content">
                    <div class="about-content-img">
                        <img src="../assets/img/design5_img.png" alt="" style="width:200px;">
                    </div>
                    <div class="about-content-text" v-if="this.isEn != '1'">
                        <div class="about-content-title">
                            产品服务
                        </div>
                        <div class="about-content-describe">
                            为客户的需求负责，提供结合硬件，软件，云服务，现场支持，全面一体的产品服务。
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="about-content-text" v-if="this.isEn == '1'">
                        <div class="about-content-title">
                           Product service
                        </div>
                        <div class="about-content-describe">
                          Responsible for customer needs, provide product services of the  combination of hardware, software, cloud services and  on-site support.
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                </div>
        </div>


        <home-foot></home-foot>
    </div>

</template>


<script>
import HomeFoot from "@/components/HomeFoot"
export default {
    name: "experience",
    components:{
        HomeFoot,
    },
    created(){
        this.isEn = sessionStorage.getItem('isEn')  == '1' ?  '1' : '0';
    },
    mounted(){
        $('.experience-scoll-page').animate({ scrollTop:0 }, 600);
    },

    data() {
        return {
            isEn:"",
        };
    },
    methods:{

    },
    watch:{


    },
    computed:{

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.experience-scoll-page{
    overflow: auto;
}
.experience-page{
    margin-top: 60px;
}
.first-page {
    /* min-height: 800px; */
    /* background: url("../assets/img/ExperienceDesignMain.png") no-repeat; */
    /* background-size: 100% 100%; */
    position: relative;
}
.first-page-title{
    color: #fff;
    text-align: center;
    position: absolute;
    top: 50%;
    right: 15%;
    margin-top: -90px;
    margin-left: -120px;
    font-size: 48px;
    font-weight: 600;
}
.first-page-title > div:nth-child(2) {
    width: 68px;
    height: 2px;
    background: #fff;
    border-radius:1px;
    margin-top: 10px;
    margin-bottom: 20px;
    margin-left: 130px;
}
.first-page-title > div:nth-child(3) {
    font-size: 24px;
    font-weight: 400;
}


/* 选项内容 */
.about-content{
    padding:150px 0;
}
.about-content > div {
  min-width: 900px;
  margin: 0 auto;
  /* margin-top: 100px; */
  /* margin-bottom: 100px; */
}
.about-content .about-content-img img{
    width: 100%;
}

.about-content-img-left{
    padding: 0 120px 0 0;
}
.about-content-img-right{
    padding: 0  0 0 120px;
}
.about-content .about-content-text{
    padding-top: 100px;
}
.about-content-text-left{
   padding-right:200px;
}
.about-content-text-right{
   padding-left: 200px;
}
.about-content .about-content-text .about-content-title{
    font-size: 32px;
    color: #2C2C2C;
    font-weight: 600;
}
.about-content .about-content-text .about-content-describe{
    margin-top: 20px;
    font-size: 22px;
    color: #2C2C2C;
    line-height: 40px;
}
.about-content .about-content-text .about-content-line{
    background: #D7DBDC;
    color: #D7DBDC;
    border-color: #D7DBDC;
    margin-top: 34px;
    width: 65px;
    height: 3px;
}

#miao3{
    margin-bottom:50px;
}

.about-content-margin{
    margin:150px auto  0!important;
}

/* 笔记本适应性 */
@media only screen and (max-width:1600px){
    .about-content .about-content-text{
        padding-top: 40px;
    }
    .about-content .about-content-text .about-content-describe{
        font-size: 20px;
        line-height: 34px;
        margin-top: 18px;
    }
    .about-content .about-content-text .about-content-line{
        margin-top: 27px;
    }
    .about-content-text-left{
    padding-right:150px;
    }
    .about-content-text-right{
    padding-left: 150px;
    }
}
/* 中屏以上  宽度修正 */
@media only screen and (max-width:1400px){
    .about-content .about-content-text{
        padding-top: 25px;
    }
    .about-content .about-content-text .about-content-describe{
        font-size: 18px;
        line-height: 30px;
        margin-top: 16px;
    }
    .about-content .about-content-text .about-content-line{
        margin-top: 26px;
    }
    .about-content-text-left{
    padding-right:100px;
    }
    .about-content-text-right{
    padding-left: 100px;
    }
}

@media only screen and (max-width:991px){

/*  移动端标签 */
.first-phone-page{
    position: relative;
}
.first-phone-page .first-page-title{
    position: absolute;
    top: 50%;
    left: 50%;
}
.phone-content{
    padding: 0 15px;
    margin-top: 50px;
    margin-bottom: 50px;
}
.phone-content .about-content-title{
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    margin-top: 10px;
}
.phone-content .about-content-img{
    text-align: center;
}
.phone-content .about-content-describe{
    font-size: 16px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/experience.vue